const { prefix, transitionEnd, animationEnd } = getTransitionProperties()

const transform = `${prefix}-transform`
const transitionProperty = `${prefix}-transition-property`
const transitionDuration = `${prefix}-transition-duration`
const transitionDelay = `${prefix}-transition-delay`
const transitionTiming = `${prefix}-transition-timing-function`

const animationName = `${prefix}-animation-name`
const animationDuration = `${prefix}-animation-duration`
const animationTiming = `${prefix}-animation-delay`
const animationDelay = `${prefix}-animation-timing-function`

export {
  transform,
  transitionProperty,
  transitionTiming,
  transitionDelay,
  transitionDuration,
  transitionEnd,
  animationName,
  animationDuration,
  animationTiming,
  animationDelay,
  animationEnd,
}

export default {
  transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration,
}

function getTransitionProperties() {
  let style = document.createElement('div').style

  const vendorMap = {
    O: e => `o${e.toLowerCase()}`,
    Moz: e => e.toLowerCase(),
    Webkit: e => `webkit${e}`,
    ms: e => `MS${e}`,
  }

  const vendors = Object.keys(vendorMap)

  let transitionEnd, animationEnd
  let prefix = ''

  for (let i = 0; i < vendors.length; i++) {
    const vendor = vendors[i]

    if (`${vendor}TransitionProperty` in style) {
      prefix = `-${vendor.toLowerCase()}`
      transitionEnd = vendorMap[vendor]('TransitionEnd')
      animationEnd = vendorMap[vendor]('AnimationEnd')
      break
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend'

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend'

  style = null

  return { animationEnd, transitionEnd, prefix }
}



// WEBPACK FOOTER //
// ./helpers/transitionProperties.js